import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../shared/Breadcrumb';

const BookingSuccess = (props) => {
    const doctor = JSON.parse(props.location.state.doctor);
    const appoinmentResult = JSON.parse(props.location.state.appoinmentResult);
    const { appoinmentDate, appoinmentTime } = props.location.state;

    console.log(appoinmentResult);

    return ( 
        <div>
            <Breadcrumb title="Booking" />
            <div className="content success-page-cont">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="card success-card">
                                <div className="card-body">
                                    <div className="success-cont">
                                        <i className="fas fa-check"></i>
                                        <h3>Appointment booked Successfully!</h3>
                                        <p>Appointment {appoinmentResult.appoinmentNumber} booked with <strong>Dr. {doctor.firstName} {doctor.lastName}</strong><br /> on <strong>{appoinmentDate} {appoinmentTime}</strong></p>
                                        <Link className="btn btn-primary view-inv-btn" to={
                                            {
                                                pathname:'/invoiceview',
                                                state: {
                                                    invoiceId: appoinmentResult.invoiceId
                                                }
                                            }
                                        }>View Invoice</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default BookingSuccess;